import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Image,
  InputGroup,
  InputRightElement,
  Text,
  useDisclosure,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Step,
  StepIcon,
  StepIndicator,
  StepNumber,
  Stepper,
  StepSeparator,
  StepStatus,
  StepTitle,
  Table,
  TableContainer,
  Tbody,
  Td,
  Thead,
  Tr,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  // useDisclosure,
} from "@chakra-ui/react";
import TableLocking from "./tableLocking";
import IconFile from "../../assets/images/booking/upfile.svg";
import iconPlus from "../../assets/images/booking/plus.svg";
import iconPlus2 from "../../assets/images/personnelCategories/plus.svg";
import PopupImport from "../../components/popup/PopupImport";
// import FormDetail from "./form/detail";
import { commonCall } from "../../api/common";
import toast from "react-hot-toast";
import { lockingCall } from "../../api/locking";
import { lockingImageCall } from "../../api/lockingImage";
import { lockingParticipantCall } from "../../api/lockingParticipant";
import { exportFile, formatDateDb } from "../../utils/tools";
import { formatDateToLocal, formatPriceUS } from "../../utils/utils";
import { useLocking } from "../../hooks/useLooking";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { lockingRelativeParticipantCall } from "../../api/lockingRelativeParticipant";
import { formatTableValue } from "./formatTable";
import iconApproved from "../../assets/images/receiveSalary/check-circle.svg";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { InputControl } from "../../components/form/formControls";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import DatePicker from "react-datepicker";
import { commissionCall } from "../../api/commission";
import StepCommissionForm from "./step3CommissionForm";

export default function ServiceFeeManagementStep3Detail({
  lockingId,
  locking,
  setLocking,
  getLocking,
  handleNext,
  handlePrevious,
}) {
  const [stepsCommission, setStepsCommission] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const [lockingRelativeParticipant, setRelativeParticipant] = useState([]);

  const getStepsCommission = async (lockingId) => {
    const data = await commissionCall.getStepByLockingId(lockingId);

    if (data) {
      setStepsCommission(data);
    }
  };

  const getLockingRelativeParticipant = async (lockingId) => {
    const participants =
      await lockingRelativeParticipantCall.getGroupRelativeParticipantsByLockingId(
        lockingId,
      );

    if (participants) {
      setRelativeParticipant(participants);
    }
  };

  useEffect(() => {
    if (lockingId) {
      getLockingRelativeParticipant(lockingId);
      getStepsCommission(lockingId);
    }
  }, [lockingId]);

  // Nhãn "ĐC T{tháng}.{năm}" theo đúng tháng/năm đối chiếu của đợt.
  // Đợt mới chưa lưu (chưa có month/year) → mặc định tháng/năm hiện tại,
  // khớp với default khi tạo mới ở StepCommissionForm.
  const formatReconciliationLabel = (step) => {
    const now = new Date();
    const month = step?.month ?? now.getMonth() + 1;
    const year = step?.year ?? now.getFullYear();
    return `T${String(month).padStart(2, "0")}.${year}`;
  };

  const newStepCommission = () => {
    const totalCommission = stepsCommission.reduce(
      (sum, item) => sum + Number(item.calculateCommissionRate || 0),
      0,
    );
    const newRate = Math.max(0, 100 - totalCommission);

    const stepInfo = {
      lockingId: lockingId,
      period: stepsCommission.length + 1,
      calculateCommissionRate: newRate,
    };

    const newSteps = [...stepsCommission, stepInfo];
    setStepsCommission(newSteps);
    setOpenIndex(newSteps.length - 1);
  };

  return (
    <Box>
      {/* button create step commission */}
      <Flex justifyContent={"flex-end"} w={"full"} mb={4}>
        {" "}
        <Button
          w={"max-content"}
          mt={"16px"}
          display={"flex"}
          alignItems={"center"}
          p={"0px 12px"}
          gap={"10px"}
          borderRadius={"8px"}
          border={"1px solid var(--color-option-employee-hover)"}
          backgroundImage="var(--color-main)"
          bg={"var(--color-main)"}
          padding={"8px 12px"}
          h={"32px"}
          _hover={{
            filter: "brightness(95%)",
          }}
          onClick={() => newStepCommission()}
        >
          <Image src={iconPlus2} />
          <Text
            fontSize={{ base: "13px" }}
            lineHeight={"16px"}
            fontWeight={600}
            color="var(--color-option-employee-hover)"
          >
            Thêm đợt đối chiếu mới
          </Text>
        </Button>
      </Flex>
      {/* List step */}
      <Accordion index={openIndex} onChange={(index) => setOpenIndex(index)}>
        {stepsCommission.map((step, index) => (
          <AccordionItem key={index}>
            <AccordionButton>
              <Box as="span" flex="1" textAlign="left">
                <Text
                  fontSize={"16px"}
                  fontWeight={"600"}
                  color="var(--color-option-employee-hover)"
                >
                  Xác nhận PDV chi tiết - ĐC {formatReconciliationLabel(step)} -
                  Đợt {step.period}
                </Text>
              </Box>
              <AccordionIcon />
            </AccordionButton>

            <AccordionPanel pb={4}>
              {openIndex === index && (
                <Box w={"100%"}>
                  <StepCommissionForm
                    step={step}
                    lockingId={lockingId}
                    locking={locking}
                    getLocking={getLocking}
                  />
                </Box>
              )}
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Box>
  );
}
